import { render } from "./FormPage.vue?vue&type=template&id=015b6070&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"

import "./FormPage.vue?vue&type=style&index=0&id=015b6070&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015b6070"]])

export default __exports__